module.exports = __webpack_public_path__ + "static/media/contact-info-icon1.2e9508c4.svg";